import { lazy } from 'react';

// project import
import Loadable from './Loadable';
import MainLayout from '../layout/AdminLayout';
//Setting menu
const ReceiptInfo = Loadable(lazy(() => import('../pages/settings/Receipt_info')));
const MerchantInfo = Loadable(lazy(() => import('../pages/settings/Merchant_info')));
const MerchantQrPayment = Loadable(lazy(() => import('../pages/settings/Merchant_qr_payment')));
const Vat = Loadable(lazy(() => import('../pages/settings/Vat')));
const ExchangeRate = Loadable(lazy(() => import('../pages/settings/ExchangeRate')));

const Sale = Loadable(lazy(() => import('../pages/sale/Sale')));
const Billsummary = Loadable(lazy(() => import('../pages/bill/Billsummary')));
const Billdone = Loadable(lazy(() => import('../pages/bill/Billdone')));
const Billpending = Loadable(lazy(() => import('../pages/bill/Billpending')));
const Billcancel = Loadable(lazy(() => import('../pages/bill/Billcancel')));
const Product = Loadable(lazy(() => import('../pages/product/Product')));
const Customer = Loadable(lazy(() => import('../pages/Customer')));
const Branch = Loadable(lazy(() => import('../pages/Branch')));
const ProductFormAE = Loadable(lazy(() => import('../components/product/ProductFormAE')));
const ProductView = Loadable(lazy(() => import('../components/product/ProductView')));
const ProductGenbarcode = Loadable(lazy(() => import('../components/product/ProductGenBarcode')));
const ProductGroup = Loadable(lazy(() => import('../pages/ProductGroup')));
const ProductType = Loadable(lazy(() => import('../pages/ProductType')));
const Stock = Loadable(lazy(() => import('../pages/Stock')));
const ProductOutofStockSoon = Loadable(lazy(() => import('../pages/ProductOutofStockSoon')));
const ProductStockExpire = Loadable(lazy(() => import('../pages/ProductStockExpire')));
const ProductStockExpired = Loadable(lazy(() => import('../pages/ProductStockExpired')));
const StockIn = Loadable(lazy(() => import('../pages/StockIn')));
const Purchaseorder = Loadable(lazy(() => import('../pages/Purchaseorder')));
const ProducStockBuyOrderFormA = Loadable(lazy(() => import('../components/purchaseorder/ProducStockPurchaseorderFormA')));
const ProducStockFormA = Loadable(lazy(() => import('../components/product_stock/ProducStockFormA')));
const Unit = Loadable(lazy(() => import('../pages/Unit')));
const Promotion = Loadable(lazy(() => import('../pages/Promotion')));
const User = Loadable(lazy(() => import('../pages/User')));
const Profile = Loadable(lazy(() => import('../pages/Profile')));
const RegisterPackage = Loadable(lazy(() => import('../pages/package/RegisterPackage')));
// Report
const Dashboard = Loadable(lazy(() => import('../pages/report/Dashboard')));
const IncomeExpenseReport = Loadable(lazy(() => import('../pages/report/IncomeExpenseReport')));
const SaleReport = Loadable(lazy(() => import('../pages/report/SaleReport')));
const ProductSaleReport = Loadable(lazy(() => import('../pages/report/ProductSaleReport')));
const ProductBuyReport = Loadable(lazy(() => import('../pages/report/ProductBuyReport')));
const ProductStockReport = Loadable(lazy(() => import('../pages/report/ProductStockReport')));
const ProductOutOfStockReport = Loadable(lazy(() => import('../pages/report/ProductOutOfStockReport')));
const ProductExpiredReport = Loadable(lazy(() => import('../pages/report/ProductExpiredReport')));
//const StockReport = Loadable(lazy(() => import('../pages/report/StockReport')));
//Page not found
const PageNotFound = Loadable(lazy(() => import('../pages/PageNotFound')));

/*
// without load affect
import User from '../pages/User';
import Userrole from '../pages/User_role';
import Profile from '../pages/Profile';
import PageNotFound from '../pages/PageNotFound';
*/

// ==============================|| MAIN ROUTING ||============================== //

const title = 'Thana';

const AdminRoutes = {
    element: <MainLayout />,
    children: [
        {
            path: '/settings/merchant_info',
            element:
                <MerchantInfo
                    documentTitle={`Merchant setting - ${title}`}
                    pageTitle='ຕັ້ງຄ່າ'
                    menuActive='/settings/merchant_info'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/settings/merchant_qr_payment',
            element:
                <MerchantQrPayment
                    documentTitle={`Merchant qr payment - ${title}`}
                    pageTitle='ຕັ້ງຄ່າ'
                    menuActive='/settings/merchant_qr_payment'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/settings/receipt_info',
            element:
                <ReceiptInfo
                    documentTitle={`Receipt setting - ${title}`}
                    pageTitle='ຕັ້ງຄ່າ'
                    menuActive='/settings/merchant_info'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: 'settings/vat',
            element:
                <Vat
                    documentTitle={`Vat setting - ${title}`}
                    pageTitle='ຕັ້ງຄ່າ'
                    menuActive='/settings/merchant_info'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: 'settings/exchange-rate',
            element:
                <ExchangeRate
                    documentTitle={`Exchange-rate setting - ${title}`}
                    pageTitle='ຕັ້ງຄ່າ'
                    menuActive='/settings/merchant_info'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/package/view',
            element:
                <RegisterPackage
                    documentTitle={`Package - ${title}`}
                    pageTitle='ແພັກແກັດ'
                    menuActive='/package/view'
                    payment_status='payment'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                    packageBtnRole={['PK00', 'PK02', 'PK03']}  // Use for some button in Sale page disable for PK01
                />
        }, {
            path: '/sale',
            element:
                <Sale
                    documentTitle={`Sale pos- ${title}`}
                    pageTitle='ຂາຍເຄື່ອງ POS'
                    menuActive='/sale'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                    packageBtnRole={['PK00', 'PK02', 'PK03']}  // Use for some button in Sale page disable for PK01
                />
        }, {
            path: '/bill',
            element:
                <Billsummary
                    documentTitle={`ໃບບີນສະຫຼຸບ - ${title}`}
                    pageTitle='ໃບບິນ'
                    menuActive='/bill'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/bill/done',
            element:
                <Billdone
                    documentTitle={`ໃບບິນສໍາເລັດ - ${title}`}
                    pageTitle='ໃບບິນ'
                    menuActive='/bill'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/bill/pending',
            element:
                <Billpending
                    documentTitle={`ໃບບິນລໍຖ້າຊໍາລະ - ${title}`}
                    pageTitle='ໃບບິນ'
                    menuActive='/bill'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/bill/cancel',
            element:
                <Billcancel
                    documentTitle={`ໃບບີນຍົກເລີກ - ${title}`}
                    pageTitle='ໃບບິນ'
                    menuActive='/bill'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product',
            element:
                <Product
                    documentTitle={`Product - ${title}`}
                    pageTitle='ຂໍ້ມູນສິນຄ້າ'
                    mainMenuActive='product'
                    menuActive='/product'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                    packageBtnRole={['PK00', 'PK02', 'PK03']}  // Use for some button in Product page disable for PK01
                />
        }, {
            path: '/product/sale/report',
            element:
                <ProductSaleReport
                    documentTitle={`ລາຍງານສິນຄ້າຂາຍອອກ - ${title}`}
                    pageTitle='ລາຍງານສິນຄ້າຂາຍອອກ'
                    mainMenuActive='report'
                    menuActive='/product/sale/report'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/view/:mid/:prdIdEdit/:prd_no',
            element:
                <ProductView
                    documentTitle={`Product view - ${title}`}
                    pageTitle='ຂໍ້ມູນລາຍລະອຽດ'
                    menuActive='/product'
                />
        }, {
            path: '/product/genbarcode/:mid/:prdIdEdit/:prd_no',
            element:
                <ProductGenbarcode
                    documentTitle={`Product view - ${title}`}
                    pageTitle='ຂໍ້ມູນລາຍລະອຽດ'
                    menuActive='/product'
                />
        }, {
            path: '/product/addform/new',
            element:
                <ProductFormAE
                    documentTitle={`Product add - ${title}`}
                    pageTitle='ເພີ່ມຂໍ້ມູນສິນຄ້າ'
                    menuActive='/product'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                    packageBtnRole={['PK00', 'PK02', 'PK03']}  // Use for some button in Product add form page disable for PK01
                />
        }, {
            path: '/product/editform/:prdIdEdit',
            element:
                <ProductFormAE
                    documentTitle={`Product edit - ${title}`}
                    pageTitle='ເເກ້ໄຂຂໍ້ມູນສິນຄ້າ'
                    menuActive='/product'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                    packageBtnRole={['PK00', 'PK02', 'PK03']}  // Use for some button in Product add form page disable for PK01
                />
        }, {
            path: '/product/stock',
            element:
                <Stock
                    documentTitle={`Product stock - ${title}`}
                    pageTitle='ຂໍ້ມູນສາງສິນຄ້າ'
                    menuActive='/product'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/outofstock/soon',
            element:
                <ProductOutofStockSoon
                    documentTitle={`Product out of stock - ${title}`}
                    pageTitle='ສິນຄ້າໄກ້ໝົດສາງ'
                    mainMenuActive='product'
                    menuActive='/product/outofstock/soon'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/expire',
            element:
                <ProductStockExpire
                    documentTitle={`Product stock expire - ${title}`}
                    pageTitle='ຂໍ້ມູນສິນຄ້າໄກ້ໝົດອາຍຸ'
                    mainMenuActive='product'
                    menuActive='/product/stock/expire'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/expired',
            element:
                <ProductStockExpired
                    documentTitle={`Product stock expired - ${title}`}
                    pageTitle='ຂໍ້ມູນສິນຄ້າໝົດອາຍຸ'
                    mainMenuActive='product'
                    menuActive='/product/stock/expire'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/in',
            element:
                <StockIn
                    documentTitle={`Product stock in - ${title}`}
                    pageTitle='ຂໍ້ມູນສາງສິນຄ້າ'
                    mainMenuActive='product'
                    menuActive='/product/stock/in'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/purchaseorder',
            element:
                <Purchaseorder
                    documentTitle={`Product stock purchaseorder - ${title}`}
                    pageTitle='ຂໍ້ມູນສາງສິນຄ້າ'
                    menuActive='/product'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/purchaseorder/add',
            element:
                <ProducStockBuyOrderFormA
                    documentTitle={`Product stock purchaseorder add - ${title}`}
                    pageTitle='ສ້າງໃບສັ່ງຊື້ສິນຄ້າ'
                    menuActive='/product'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/purchaseorder/edit/:purchaseorderid',
            element:
                <ProducStockBuyOrderFormA
                    documentTitle={`Product stock purchaseorder edit - ${title}`}
                    pageTitle='ສ້າງໃບສັ່ງຊື້ສິນຄ້າ'
                    menuActive='/product/stock/purchaseorder'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/in/add',
            element:
                <ProducStockFormA
                    documentTitle={`Product stock add - ${title}`}
                    pageTitle='ເພີ່ມສິນຄ້າເຂົ້າສາງ'
                    menuActive='/product/stock/in'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/dashboard',
            element:
                <Dashboard
                    documentTitle={`Main Dashboard - ${title}`}
                    pageTitle='Dashboard'
                    menuActive='/dashboard'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                    packageBtnRole={['PK00', 'PK01', 'PK02', 'PK03']}  // Use for some button in dashboard page disable for PK01
                />
        }, {
            path: '/income_expense/report',
            element:
                <IncomeExpenseReport
                    documentTitle={`Sale report - ${title}`}
                    pageTitle='ລາຍງານລາຍຮັບ-ລາຍຈ່າຍ'
                    mainMenuActive='report'
                    menuActive='/income_expense/sale'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/sale/report',
            element:
                <SaleReport
                    documentTitle={`Sale report - ${title}`}
                    pageTitle='ລາຍງານການຂາຍ'
                    mainMenuActive='report'
                    menuActive='/report/sale'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/buy/report',
            element:
                <ProductBuyReport
                    documentTitle={`Buy report - ${title}`}
                    pageTitle='ລາຍງານສິນຄ້າຊື້ເຂົ້າ'
                    mainMenuActive='report'
                    menuActive='product/buy/report'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/stock/report',
            element:
                <ProductStockReport
                    documentTitle={`ລາຍງານສິນຄ້າໃນສາງ - ${title}`}
                    pageTitle='ລາຍງານສິນຄ້າໃນສາງ'
                    mainMenuActive='report'
                    menuActive='/product/stock/report'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/outofstock/report',
            element:
                <ProductOutOfStockReport
                    documentTitle={`ລາຍງານສິນຄ້າໃນສາງ - ${title}`}
                    pageTitle='ລາຍງານສິນຄ້າໝົດສາງ'
                    mainMenuActive='report'
                    menuActive='/product/outofstock/report'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/expire/report',
            element:
                <ProductExpiredReport
                    documentTitle={`ລາຍງານສິນຄ້າໃນສາງ - ${title}`}
                    pageTitle='ລາຍງານສິນຄ້າໝົດອາຍຸ'
                    mainMenuActive='report'
                    menuActive='/product/expire/report'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/customer',
            element:
                <Customer
                    documentTitle={`Customer - ${title}`}
                    pageTitle='ຂໍ້ມູນລູກຄ້າ'
                    menuActive='/customer'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/group',
            element:
                <ProductGroup
                    documentTitle={`Product group - ${title}`}
                    pageTitle='ຂໍ້ມູນກຸ່ມ, ປະເພດ, ຫົວໜ່ວຍ ສິນຄ້າ'
                    mainMenuActive='product'
                    menuActive='/product/group'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/type',
            element:
                <ProductType
                    documentTitle={`Product type - ${title}`}
                    pageTitle='ຂໍ້ມູນກຸ່ມ, ປະເພດ, ຫົວໜ່ວຍ ສິນຄ້າ'
                    mainMenuActive='product'
                    menuActive='/product/group'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/product/unit',
            element:
                <Unit
                    documentTitle={`Unit - ${title}`}
                    pageTitle='ຂໍ້ມູນກຸ່ມ ປະເພດ ຫົວໜ່ວຍ ສິນຄ້າ'
                    mainMenuActive='product'
                    menuActive='/product/group'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/promotion',
            element:
                <Promotion
                    documentTitle={`Promotion - ${title}`}
                    pageTitle='ໂປໂມຊັ່ນ'
                    menuActive='/promotion'
                />
        }, {
            path: '/branch',
            element:
                <Branch
                    documentTitle={`Branch - ${title}`}
                    pageTitle='ຂໍ້ມູນສາຂາ'
                    menuActive='/branch'
                    package={['PK02', 'PK03']}
                />
        }, {
            path: '/user',
            element:
                <User
                    documentTitle={`User - ${title}`}
                    mainMenuActive='user'
                    pageTitle='ຂໍ້ມູນຜູ້ໃຊ້ລະບົບ'
                    menuActive='/user'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/profile',
            element:
                <Profile
                    documentTitle={`Profile - ${title}`}
                    pageTitle='ຂໍ້ມູນສ່ວນຕົວ'
                    mainMenuActive='user'
                    menuActive='/profile'
                    package={['PK00', 'PK01', 'PK02', 'PK03']}
                />
        }, {
            path: '/*',
            element: (
                <PageNotFound
                    documentTitle={`Page Not Found - ${title}`}
                    pageTitle=''
                    menuActive=''
                />
            )
        }
    ]
};

export default AdminRoutes;
